
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import AdvancedErrorBoundary from "@/components/common/AdvancedErrorBoundary";
import LoadingSpinner from "@/components/ui/loading-spinner";
import ScrollToTop from "@/components/common/ScrollToTop";


import About from "@/pages/About";
import PricingPage from "@/pages/Pricing";
import ContactPage from "@/pages/Contact";
import TestimonialsPage from "@/pages/Testimonials";
import Gallery from "@/pages/Gallery";
import RezerwacjaPage from "@/pages/Rezerwacja";
import TermsPage from "@/pages/Terms";

const Index = lazy(() => import("@/pages/Index"));
const GlossaryPage = lazy(() => import("@/pages/Glossary"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const NotFound = lazy(() => import("@/pages/NotFound"));

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div className="fixed inset-0 flex items-center justify-center bg-garage-darker z-[9999]"><LoadingSpinner size="lg" /></div>}>
        <Routes>
          <Route path="/" element={
            <AdvancedErrorBoundary context="homepage">
              <Index />
            </AdvancedErrorBoundary>
          } />
          <Route path="/o-nas" element={
            <AdvancedErrorBoundary context="about">
              <About />
            </AdvancedErrorBoundary>
          } />
          <Route path="/galeria" element={
            <AdvancedErrorBoundary context="gallery">
              <Gallery />
            </AdvancedErrorBoundary>
          } />
          <Route path="/cennik" element={
            <AdvancedErrorBoundary context="pricing">
              <PricingPage />
            </AdvancedErrorBoundary>
          } />
          <Route path="/rezerwacje" element={
            <AdvancedErrorBoundary context="rezerwacja">
              <RezerwacjaPage />
            </AdvancedErrorBoundary>
          } />
          <Route path="/slownik-pojec" element={
            <AdvancedErrorBoundary context="glossary">
              <GlossaryPage />
            </AdvancedErrorBoundary>
          } />
          <Route path="/opinie" element={
            <AdvancedErrorBoundary context="testimonials">
              <TestimonialsPage />
            </AdvancedErrorBoundary>
          } />
          <Route path="/kontakt" element={
            <AdvancedErrorBoundary context="contact">
              <ContactPage />
            </AdvancedErrorBoundary>
          } />
          <Route path="/regulamin" element={
            <AdvancedErrorBoundary context="terms">
              <TermsPage />
            </AdvancedErrorBoundary>
          } />
          <Route path="/blog" element={
            <AdvancedErrorBoundary context="blog-list">
              <Blog />
            </AdvancedErrorBoundary>
          } />
          <Route path="/blog/:slug" element={
            <AdvancedErrorBoundary context="blog-post">
              <BlogPost />
            </AdvancedErrorBoundary>
          } />
          <Route path="*" element={
            <AdvancedErrorBoundary context="404">
              <NotFound />
            </AdvancedErrorBoundary>
          } />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
